import React from 'react';
import './add client.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { message, TreeSelect } from "antd";
import { hasValue } from "../../validations/validations";
const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;
class AddClient extends React.Component {
  state = {
    clientName: '',
    clientPhone: '',
    clientCountry: null,
    city: null,
    area: null,
    category: null,
    subCategory: null,
    contractType: 'SALE',
    notes: "",
    countries: [],
    cities: [],
    areas: [],
    categories: [],
    subCategories: [],
  };

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    this.getCountries()
    this.getCategory()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getCountries = () => {
    axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ countries: response.data.data })
      })
      .catch(error => {
        console.log("ALL countries ERROR")
        console.log(error.response)
      })
  }
  getAreas = (city) => {
    axios.get(`${BASE_END_POINT}areas/${city}/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ areas: response.data.data })
      })
      .catch(error => {
        console.log("ALL areas ERROR")
        console.log(error.response)
      })
  }
  getCities = (country) => {
    axios.get(`${BASE_END_POINT}countries/${country}/cities/withoutPagenation/get?country=${country}`)
      .then(response => {
        console.log(response.data)
        this.setState({ cities: response.data.data })
      })
      .catch(error => {
        console.log("ALL cities ERROR")
        console.log(error.response)
      })
  }
  getCategory = () => {
    axios.get(`${BASE_END_POINT}categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ categories: response.data.data })
      })
      .catch(error => {
        console.log("ALL categories ERROR")
        console.log(error.response)
      })
  }
  getSubCategory = (category) => {
    axios.get(`${BASE_END_POINT}categories/${category}/sub-categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ subCategories: response.data.data })
      })
      .catch(error => {
        console.log("ALL subCategories ERROR")
        console.log(error.response)
      })
  }
  add = () => {
    const { clientName, clientPhone, clientCountry, city, area, category, subCategory, contractType, notes } = this.state
    if (hasValue(clientName) && hasValue(clientPhone) && clientCountry != null
      && city != null && area != null && category != null && subCategory != null) {
      let l = message.loading('Wait..', 2.5)
      let data = {
        "clientName": clientName,
        "clientPhone": clientPhone,
        "clientCountry": clientCountry,
        "region": 1,
        "city": city,
        "area": area,
        "category": category,
        "subCategory": subCategory,
        "contractType": contractType,
        "notes": notes
      }
      axios.post(`${BASE_END_POINT}clients`, data, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en'
        },
      })
        .then(response => {
          console.log("dd client  ", response.data)
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.goBack()
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
        })
    }
  }
  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.add()
  };
  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('CLIENTS')) return <Redirect to='/Home' />
    return (
      <div className="App">
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <div className="infoCard">
                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                  <CardMedia
                    style={{ height: "0px" }}
                  />
                  <CardHeader></CardHeader>
                  <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                    <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                      <span class="material-icons" style={{ color: 'white', fontSize: 20 }}>contact_phone</span>
                    </div>
                    <div className="tableTitle" style={{
                      display: 'inline-block', marginTop: '-60px',
                      marginLeft: '0', marginRight: '0'
                    }}>
                      <p>{allStrings.addClient}</p>
                    </div>
                  </div>
                  <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                    <MDBContainer>

                      <MDBRow>
                        <MDBCol md="12">
                          <form
                            className="needs-validation"
                            onSubmit={this.submitHandler}
                            noValidate
                          >
                            <div className="grey-text">
                              <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientName}</label>
                                    <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.clientName} type="text" id="form645" name="clientName" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..." />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientPhone}</label>
                                    <input onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.clientPhone} type="text" id="form56" name="clientPhone" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..." />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                <MDBCol md="6">
                                  <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.country}</label>
                                  <TreeSelect virtual={false}
                                    showSearch={true}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                    treeCheckable={false}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.country}
                                    onChange={(value) => {
                                      console.log(value)
                                      this.setState({ clientCountry: value });
                                      this.getCities(value)
                                    }}

                                  >
                                    {this.state.countries.map(val => (
                                      <TreeNode value={val.id} title={this.props.isRTL ? val.countryName_ar : val.countryName_en} key={val.id} />
                                    ))}
                                  </TreeSelect>
                                </MDBCol>
                                <MDBCol md="6">
                                  <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.city}</label>
                                  <TreeSelect virtual={false}
                                    showSearch={true}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                    treeCheckable={false}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.city}
                                    onChange={(value) => {
                                      console.log(value)
                                      this.setState({ city: value });
                                      this.getAreas(value)
                                    }}

                                  >
                                    {this.state.cities.map(val => (
                                      <TreeNode value={val.id} title={this.props.isRTL ? val.cityName_ar : val.cityName_en} key={val.id} />
                                    ))}
                                  </TreeSelect>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                <MDBCol md="6">
                                  <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.area}</label>
                                  <TreeSelect virtual={false}
                                    showSearch={true}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                    treeCheckable={false}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.area}
                                    showCheckedStrategy={SHOW_PARENT}
                                    onChange={(value) => {
                                      console.log(value)
                                      this.setState({ area: value });
                                    }}
                                  >
                                    {this.state.areas.map(val => (
                                      <TreeNode value={val.id} title={this.props.isRTL ? val.areaName_ar : val.areaName_en} key={val.id} />
                                    ))}
                                  </TreeSelect>
                                </MDBCol>
                                <MDBCol md="6">
                                  <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.contractType}</label>
                                  <TreeSelect virtual={false}
                                    showSearch={true}
                                    value={this.state.contractType}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                    treeCheckable={false}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.contractType}
                                    onChange={(value) => {
                                      console.log(value)
                                      this.setState({ contractType: value });
                                    }}
                                  >
                                    <TreeNode value="SALE" title={allStrings.sale} key="SALE" />
                                    <TreeNode value="RENT" title={allStrings.rent} key="RENT" />
                                  </TreeSelect>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                <MDBCol md="6">
                                  <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.category}</label>
                                  <TreeSelect virtual={false}
                                    showSearch={true}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                    treeCheckable={false}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.category}
                                    showCheckedStrategy={SHOW_PARENT}
                                    onChange={(value) => {
                                      console.log(value)
                                      this.setState({ category: value });
                                      this.getSubCategory(value)
                                    }}

                                  >
                                    {this.state.categories.map(val => (
                                      <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                                    ))}
                                  </TreeSelect>
                                </MDBCol>
                                <MDBCol md="6">
                                  <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.subCategory}</label>
                                  <TreeSelect virtual={false}
                                    showSearch={true}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                    treeCheckable={false}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.subCategory}
                                    showCheckedStrategy={SHOW_PARENT}
                                    onChange={(value) => {
                                      console.log(value)
                                      this.setState({ subCategory: value });
                                    }}

                                  >
                                    {this.state.subCategories.map(val => (
                                      <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                                    ))}
                                  </TreeSelect>
                                </MDBCol>

                              </MDBRow>
                              <MDBRow>
                                <MDBCol md="12">
                                  <div class="md-form">
                                    <label for="form9220" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.notes}</label>
                                    <br></br>
                                    <textarea style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 0' }} type="text" id="form9220" class="form-control" validate name="notes" placeholder="أدخل الملاحظات..." />
                                  </div>
                                </MDBCol>
                              </MDBRow>

                            </div>
                            <br></br>
                            <br></br>
                            <div className="text-center">
                              <MDBBtn
                                style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                                rounded
                                color="#1D9598"
                                type="submit"
                                className="btn-block z-depth-1a"
                              >
                                <MDBIcon icon="plus" className="mr-2" />
                                {allStrings.add}
                              </MDBBtn>
                            </div>
                          </form>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </CardContent>
                </Card>
              </div>
            </MDBCol>
          </MDBRow>

        </MDBContainer>

      </div>
    )
  }
}


const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(AddClient)
);